// Mirror of backend product catalog used by the frontend for fast rendering.
// Prices/specs match /api/products.
import { UNLIMITED_DEVICES } from "@/lib/constants";

export const PRODUCTS = [
  {
    id: "huntheal-antivirus-pc",
    name: "Huntheal Antivirus for PC",
    tagline: "Premium PC protection at a fair price",
    description:
      "Huntheal Antivirus delivers real-time threat detection, ransomware shield, phishing protection and a lightweight system footprint — purpose-built for Windows PCs. Buy once, get a full year of protection with unlimited updates.",
    devices: 5,
    category: "Antivirus",
    popular: true,
    image: "https://images.unsplash.com/photo-1614064548237-096f735f344f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    features: [
      "Real-Time Threat Protection",
      "Ransomware Shield",
      "Anti-Phishing & Web Protection",
      "Smart Firewall",
      "Automatic Definition Updates",
      "Lightweight PC Footprint",
      "24/7 Customer Support",
      "1 Year of Full Coverage",
    ],
    plans: [
      { id: "huntheal-1pc", label: "1 PC / 1 Year", price: 34.95, original: 69.99, billing: "annually", devices: 1 },
      { id: "huntheal-3pc", label: "3 PCs / 1 Year", price: 39.95, original: 89.99, billing: "annually", devices: 3 },
      { id: "huntheal-5pc", label: "5 PCs / 1 Year", price: 44.95, original: 109.99, billing: "annually", devices: 5 },
    ],
  },
];

export const findProduct = (id) => PRODUCTS.find((p) => p.id === id);
export const findPlan = (productId, planId) => {
  const p = findProduct(productId);
  return p?.plans.find((pl) => pl.id === planId);
};

export const CATEGORIES = ["All", "Antivirus"];

export const BRANDS = ["All", "Huntheal"];

// Derive brand from product id prefix.
export const getBrand = (product) => {
  if (!product?.id) return "";
  const prefix = product.id.split("-")[0];
  const map = { huntheal: "Huntheal" };
  return map[prefix] || prefix.charAt(0).toUpperCase() + prefix.slice(1);
};
